export default __webpack_public_path__ + "static/media/home-business-tab-img01.8bc1bbf1.jpg";